import React from 'react';
import { Stack, SxProps, Theme } from '@mui/material';
import { CircleBone } from '../../atoms/CircleBone/CircleBone';

interface StatusGroupBoneProps {
    /** Nombre de statuts */
    count?: number;
    /** Taille des statuts */
    statusSize?: string;
    /** Direction d'affichage */
    direction?: 'row' | 'column';
    /** Espacement entre les éléments */
    spacing?: number;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const StatusGroupBone: React.FunctionComponent<StatusGroupBoneProps> = function ({
    count = 3,
    statusSize = '30px',
    direction = 'row',
    spacing = 1,
    sx = {},
}) {
    return (
        <Stack
            direction={direction}
            spacing={spacing}
            sx={sx}
        >
            {Array.from({ length: count }).map((_, index) => (
                <CircleBone
                    key={`status-${count}-${index + 1}`}
                    sx={{ width: statusSize, height: statusSize }}
                />
            ))}
        </Stack>
    );
};
